/* =================== LAYOUT LP =================== */
$(function () {
  // Header: fundo sólido ao rolar a página
  const $header = $(".lp-header");
  if ($header.length > 0) {
    function toggleHeader() {
      $header.toggleClass("active", $(window).scrollTop() > 60);
    }
    toggleHeader();
    $(window).on("scroll", debounce(toggleHeader, 10));
  }

  // Etapas: preenche a linha de progresso quando a seção aparece
  $(".lp-etapas").each(function () {
    const etapas = this;
    if (!("IntersectionObserver" in window)) {
      etapas.classList.add("ativo");
      return;
    }
    etapas.classList.add("pronto");
    onElementVisible(etapas, () => etapas.classList.add("ativo"), true, 0.35);
  });

  // Benefícios: entra os cards em sequência quando a seção aparece
  $(".lp-beneficios").each(function () {
    const secao = this;
    if (!("IntersectionObserver" in window)) {
      secao.classList.add("ativo");
      return;
    }
    secao.classList.add("pronto");
    onElementVisible(secao, () => secao.classList.add("ativo"), true, 0.2);
  });

  // Sobre: revela as fotos e os recursos quando a seção aparece
  $(".lp-sobre").each(function () {
    const secao = this;
    if (!("IntersectionObserver" in window)) return;
    secao.classList.add("pronto");
    onElementVisible(secao, () => secao.classList.add("ativo"), true, 0.25);
  });

  // Sobre: fotos em camadas acompanham o cursor (parallax)
  if (window.matchMedia("(pointer: fine)").matches) {
    $(".lp-fotos-impacto")
      .on("mousemove", function (e) {
        const rect = this.getBoundingClientRect();
        this.style.setProperty("--px", ((e.clientX - rect.left) / rect.width - 0.5) * 2);
        this.style.setProperty("--py", ((e.clientY - rect.top) / rect.height - 0.5) * 2);
      })
      .on("mouseleave", function () {
        this.style.setProperty("--px", 0);
        this.style.setProperty("--py", 0);
      });
  }

  // Equipamentos: card inclina e a foto acompanha o cursor
  if (window.matchMedia("(pointer: fine)").matches) {
    $(".lp-produto")
      .on("mousemove", function (e) {
        const rect = this.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        this.style.setProperty("--ry", x * 10 + "deg");
        this.style.setProperty("--rx", y * -10 + "deg");
        this.style.setProperty("--tx", x * 2);
        this.style.setProperty("--ty", y * 2);
      })
      .on("mouseleave", function () {
        ["--rx", "--ry", "--tx", "--ty"].forEach((v) => this.style.removeProperty(v));
      });
  }

  // Seletor segmentado: destaca o grupo quando a validação falha
  if (window.Parsley) {
    window.Parsley.on("field:error", function () {
      this.$element.closest(".lp-segmentado").addClass("erro");
    }).on("field:success", function () {
      this.$element.closest(".lp-segmentado").removeClass("erro");
    });
  }

  // Seletor segmentado: revalida ao escolher uma opção
  $(".lp-segmentado input").on("change", function () {
    if (typeof $(this).parsley === "function") {
      $(this).parsley().validate();
    }
  });
});
